import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const FinalImpressionRoute = LazyLoad(
  lazy(() => import('./final-impression').then((module) => ({ default: module.FinalImpression }))),
);
